import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";
import Splitting from 'splitting';
import 'splitting/dist/splitting.css';
const timeouts = [];

const main = (props) => {
  console.log({ props });
  const { id, format, data, templateName } = props;
  const { fields } = data.data || {};
  const facts = fields.filter(({ type }) => type === "html");
  const timeouts = [];

  const timeline = anime.timeline();

  const templateDuration = 10;
  // getTemplateDurationOveride({
  //   apiSetup: props?.apiSetup,
  //   tournamentId: props?.data?.event?.competitionId,
  //   fallback:
  //     _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
  //   templateName,
  //   event: data?.event,
  // });

  $(`#${id} .ant-progress-bg`).css("width", "100%");
  $(`#${id} .ant-progress-bg`).css(
    "transition-duration",
    `${templateDuration}s`,
  );

  anime({
    targets: [`#${id} .left-block-side`],
    duration: 1400,
    easing: "linear",
    delay: 0,
  });

  anime({
    targets: [`#${id} .right-block-side`],
    rotateY: ["50deg", 0],
    width: [600, 900],
    duration: 800,
    easing: "linear",
    delay: 0,
  });

  anime({
    targets: [`#${id} .right-block-side img`],
    scale: [1, 1.4],
    duration: 2500,
    easing: "linear",
    delay: 2000,
  });


  anime({
    targets: [`#${id} .left-block-side`],
    rotateY: ["-50deg", 0],
    width: [600, 900],
    duration: 800,
    easing: "linear",
    delay: 0,
  });

  anime({
    targets: [`#${id} .left-block-side img`],
    scale: [1, 1.4],
    duration: 2500,
    easing: "linear",
    delay: 2000,
  });

  anime({
    targets: [`#${id} .main-logo img`],
    opacity: [0, 1],
    duration: 1000,
    easing: "linear",
    delay: 100,
  });

  anime({
    targets: [`#${id} .header-title`],
    translateX: [-50, 0],
    opacity: [0, 1],
    duration: 600,
    easing: "linear",
    delay: 400,
  });

  anime({
    targets: [`#${id} .facts-content`],
    // fontSize: [0,'75px'],
    duration: 600,
    easing: "linear",
    delay: 400,
  });

  if (facts) {
    for (const fact of facts) {
      if (fact?.value) {
        const timeout = setTimeout(() => {
          const results = Splitting({
            target: [".player-facts-fact"], by: 'lines', whitespace: true,
          });
          anime({
            targets: '.player-facts-fact',
            opacity: [0, 1],
            delay: 0,
            easing: 'easeOutQuad',
          });
          for (let i = 0; i < results.length; i++) {
            const result = results[i];
            const lines = result.lines;
            for (let lI = 0; lI < lines.length; lI++) {
              const line = lines[lI];
              anime({
                targets: line,
                opacity: [0, 1],
                translateY: [20, 0],
                delay: 300 + lI * 500,
                easing: 'easeOutQuad',
              });
            }
          }
        }, 500);

        return () => clearTimeout(timeout);
      }
    }
  }

  return {
    timeline: timeline,
    timeouts: timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
